import { colors } from "./colors";

export const buttonGradients = {
  blueToGreen: [colors["blue.400"], colors["lime.500"]],
  pinkToPurple: [colors["pink.500"], colors["indigo.400"]],
  amberToRed: [colors["yellow.500"], colors["red.500"]],
  amberToGreen: [colors["yellow.500"], colors["lime.500"]]
}

export type ButtonGradientType = keyof typeof buttonGradients;